/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ area: "abdomen" | "back" | "chest" | "legs" | "lower_back" | "shoulders" }} Today_Checkin_AreaInputs */

const en_us2_today_checkin_area = /** @type {(inputs: Today_Checkin_AreaInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`Chest`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`Back`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`Lower back`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`Shoulders`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`Legs`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`Abs`);
	return /** @type {LocalizedString} */ ("today.checkin_area");
};

const pt_br2_today_checkin_area = /** @type {(inputs: Today_Checkin_AreaInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`Peito`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`Costas`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`Lombar`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`Ombros`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`Pernas`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`Abdômen`);
	return /** @type {LocalizedString} */ ("today.checkin_area");
};

const es_419_today_checkin_area = /** @type {(inputs: Today_Checkin_AreaInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`Pecho`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`Espalda`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`Zona lumbar`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`Hombros`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`Piernas`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`Abdomen`);
	return /** @type {LocalizedString} */ ("today.checkin_area");
};

const pt_pt2_today_checkin_area = /** @type {(inputs: Today_Checkin_AreaInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`Peito`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`Costas`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`Lombar`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`Ombros`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`Pernas`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`Abdómen`);
	return /** @type {LocalizedString} */ ("today.checkin_area");
};

const fr_fr2_today_checkin_area = /** @type {(inputs: Today_Checkin_AreaInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`Pectoraux`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`Dos`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`Bas du dos`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`Épaules`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`Jambes`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`Abdos`);
	return /** @type {LocalizedString} */ ("today.checkin_area");
};

const de_de2_today_checkin_area = /** @type {(inputs: Today_Checkin_AreaInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`Brust`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`Rücken`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`Unterer Rücken`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`Schultern`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`Beine`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`Bauch`);
	return /** @type {LocalizedString} */ ("today.checkin_area");
};

const it_it2_today_checkin_area = /** @type {(inputs: Today_Checkin_AreaInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`Petto`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`Schiena`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`Zona lombare`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`Spalle`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`Gambe`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`Addome`);
	return /** @type {LocalizedString} */ ("today.checkin_area");
};

/**
* | area | output |
* | --- | --- |
* | "chest" | "Chest" |
* | "back" | "Back" |
* | "lower_back" | "Lower back" |
* | "shoulders" | "Shoulders" |
* | "legs" | "Legs" |
* | "abdomen" | "Abs" |
*
* @param {Today_Checkin_AreaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_area = /** @type {((inputs: Today_Checkin_AreaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_AreaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_area(inputs)
	if (locale === "es-419") return es_419_today_checkin_area(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_area(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_area(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_area(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_area(inputs)
	return en_us2_today_checkin_area(inputs)
});
export { today_checkin_area as "today.checkin_area" }